import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useGames } from '../hooks/useGames';
import { GameList } from '../components/GameList';
import { Search, ArrowLeft, Loader2 } from 'lucide-react';

export function SearchResults() {
  const [searchParams, setSearchParams] = useSearchParams();
  const query = searchParams.get('q') || '';
  const navigate = useNavigate();
  const { games, isLoading, error } = useGames(null, query);

  const handleSearch = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const newQuery = formData.get('search') as string;
    if (newQuery.trim()) {
      setSearchParams({ q: newQuery.trim() });
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex items-center gap-4 mb-8">
          <button
            onClick={() => navigate('/')}
            className="p-2 hover:bg-gray-100 rounded-full"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>

          <form onSubmit={handleSearch} className="flex-1 max-w-2xl">
            <div className="relative">
              <input
                type="search"
                name="search"
                defaultValue={query}
                placeholder="Search for a game..."
                className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
              />
              <button
                type="submit"
                className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 text-gray-400 hover:text-indigo-600"
              >
                <Search className="w-5 h-5" />
              </button>
            </div>
          </form>
        </div>

        {isLoading ? (
          <div className="flex items-center justify-center h-64">
            <Loader2 className="w-8 h-8 animate-spin text-indigo-600" />
          </div>
        ) : error ? (
          <div className="text-center py-12">
            <p className="text-red-600">{error}</p>
          </div>
        ) : games.length > 0 ? (
          <GameList
            games={games}
            viewMode="list"
            onSelectGame={(id) => navigate(`/game/${id}`)}
          />
        ) : (
          <div className="text-center py-12">
            <p className="text-gray-500 text-lg">
              No games found matching "{query}"
            </p>
          </div>
        )}
      </div>
    </div>
  );
}